var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u624B\u673A_current@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186FF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186FF0",
    stopOpacity: 0.75,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u63A7\\u4EF6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u624B\\u673A"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248",
    opacity: 0.100000001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,3 C15.5522847,3 16,3.44771525 16,4 L16,16 C16,16.5522847 15.5522847,17 15,17 L5,17 C4.44771525,17 4,16.5522847 4,16 L4,4 C4,3.44771525 4.44771525,3 5,3 L15,3 Z M7.69098301,4.5 L6,4.5 C5.75454011,4.5 5.55039163,4.67687516 5.50805567,4.91012437 L5.5,5 L5.5,15 C5.5,15.2454599 5.67687516,15.4496084 5.91012437,15.4919443 L6,15.5 L14,15.5 C14.2454599,15.5 14.4496084,15.3231248 14.4919443,15.0898756 L14.5,15 L14.5,5 C14.5,4.75454011 14.3231248,4.55039163 14.0898756,4.50805567 L14,4.5 L12.309017,4.5 C12.1511953,4.5 12.0046614,4.57430638 11.9111869,4.69710296 L11.8618034,4.7763932 L11.6381966,5.2236068 C11.5676166,5.36476681 11.435623,5.46259986 11.2839873,5.49128976 L11.190983,5.5 L8.80901699,5.5 C8.6511953,5.5 8.50466144,5.42569362 8.41118686,5.30289704 L8.3618034,5.2236068 L8.1381966,4.7763932 C8.05350059,4.60700119 7.88036903,4.5 7.69098301,4.5 Z M11.75,12.5 C11.8880712,12.5 12,12.6119288 12,12.75 L12,13.75 C12,13.8880712 11.8880712,14 11.75,14 L8.25,14 C8.11192881,14 8,13.8880712 8,13.75 L8,12.75 C8,12.6119288 8.11192881,12.5 8.25,12.5 L11.75,12.5 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneActive);
export default __webpack_public_path__ + "static/media/phone-active.356ef8008a52a3319f21d6a69ead55b0.svg";
export { ForwardRef as ReactComponent };